import { Outlet } from "react-router";
import Header from "./Header";
import Footer from "./Footer";
import Contact from "@/components/molecule/Contact";
import ScrollToTop from "@/components/atom/ScrollToTop";

const MainLayout = () => {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Outlet />
      <Contact />
      <Footer />
    </>
  );
};

export default MainLayout;
